/**
 * Narrow entry point for `SQLITE_BUSY` containment.
 *
 * Kept separate from the main barrel (`+.ts`) for the same reason as
 * `turso-sync.ts`: the barrel re-exports `openSqliteDatabase`, which has a
 * top-level expo-sqlite import. This module has NO runtime dependencies at all,
 * so importing through this subpath is safe from the server bundle
 * (`actor-database.server.ts` → `wrap-actor-database.ts`) and from the web graph.
 */
export {
  isDatabaseLockedError,
  retryOnDatabaseLocked,
  withSqliteBusyRetry,
  type DatabaseLockRetryOptions,
} from "#with-sqlite-busy-retry";
